import { render, staticRenderFns } from "./LKPublicationsFormdataList.vue?vue&type=template&id=3171c9b4&scoped=true&"
import script from "./LKPublicationsFormdataList.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataList.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataList.vue?vue&type=style&index=0&id=3171c9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3171c9b4",
  null
  
)

export default component.exports